/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import classNames from 'classnames';
import { useForm } from '@folklore/forms';

import * as AppPropTypes from '../../lib/PropTypes';
import TextField from '../fields/Text';
import Button from '../buttons/Button';

import styles from '../../../styles/forms/newsletter.scss';

const messages = defineMessages({
    email: {
        id: 'content.email_placeholder',
        defaultMessage: 'Your email',
    },
    button: {
        id: 'content.subscribe_button',
        defaultMessage: 'Subscribe',
    },
});

const propTypes = {
    action: PropTypes.string,
    errors: AppPropTypes.formErrors,
    className: PropTypes.string,
    onComplete: PropTypes.func,
};

const defaultProps = {
    action:
        'https://findingsally.us4.list-manage.com/subscribe/post?u=784a24a83ccfd78c914af433c&amp;id=98421caba4',
    errors: null,
    className: null,
    onComplete: null,
};

const NewsletterForm = ({ action, errors, className, onComplete }) => {
    const { fields, loading } = useForm({
        action,
        fields: ['EMAIL'],
        errors,
        onComplete,
    });
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <form action={action} method="POST">
                <div style={{ position: 'absolute', left: -5000 }} aria-hidden="true">
                    <input type="text" name="b_784a24a83ccfd78c914af433c_98421caba4" tabIndex="-1" value="" />
                </div>
                <div className={styles.row}>
                    <TextField
                        type="email"
                        placeholder={messages.email}
                        inputClassName={styles.input}
                        {...fields.EMAIL}
                    />
                    <Button
                        type="submit"
                        label={messages.button}
                        className={styles.button}
                        disabled={loading}
                        loading={loading}
                        green
                    />
                </div>
            </form>
        </div>
    );
};

NewsletterForm.propTypes = propTypes;
NewsletterForm.defaultProps = defaultProps;

export default NewsletterForm;
